/* @flow */
import cx from 'classnames';
import * as React from 'react';

import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';

import './SchoolViewChartFigure.scss';

type Props = {
  chartType: 'communication' | 'reach',
  children: React.Node,
  copy: string,
  title: React.Node,
};

export default function SchoolViewChartFigure({ chartType, children, copy, title }: Props) {
  return (
    <MediaObject
      center
      gutter="xxxxlarge"
      className={cx('SchoolViewChartFigure', `SchoolViewChartFigure--${chartType}`)}>
      <div className="SchoolViewChartFigure-chart">
        <Text color="graphite" size="xxxsmall">
          {children}
        </Text>
      </div>
      <div>
        <Row size="small">
          <Text element="h3" size="xlarge" weight="semibold">
            {title}
          </Text>
        </Row>
        <Text element="p" size="medium">
          {copy}
        </Text>
      </div>
    </MediaObject>
  );
}
